import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { filterDate_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template";

declare var ko: any;

export class modReportsDailyDownloads_template extends vnTemplate {

    protected dateFilter: filterDate_template;

    protected getTemplateHtml(): string {
        return `
            <div class="mod-reports-daily-downloads">
                <div class="sub-header w-justify">
                    <div class="w-left">
                        ${this.dateFilter.getHtmlBuild()}
                        <button type="button" class="btn highlight" data-bind="click: onClickApply, disable: loading">Run report</button>
                    </div>
                </div>
                <div class="w-list-results" id="list-results">
                    <table class="list-results">
                        <thead>
                            <tr>
                                <th>Day</th>
                                <th>Total downloads</th>
                                <th>Unique downloads</th>
                            </tr>
                        </thead>
                        <tbody data-bind="foreach: rows">
                            <tr data-bind="css: { 'mod-reports-total-row': isTotal }">
                                <td data-bind="text: day"></td>
                                <td data-bind="text: totalDownloads"></td>
                                <td data-bind="text: uniqueDownloads"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        `;
    }

    protected initPartial(): void {
        this.dateFilter = new filterDate_template("dateFilter", this.getTemplateViewModel(), this.caller);
        this.dateFilter.setLabel("Date range");
        this.dateFilter.toggleClearButton(true);
        this.dateFilter.setStartPickerId("mod-reports-dd-start");
        this.dateFilter.setEndPickerId("mod-reports-dd-end");
        const now = new Date();
        const start = new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0);
        const end = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
        this.dateFilter.setDateRange(start, end);
    }

    protected getTemplateName(): string {
        return "modReportsDailyDownloads_template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): string[] {
        return ["w-content"];
    }

    protected buildViewModel(): any {
        const caller = this.caller;
        return {
            rows: ko.observableArray([]),
            loading: ko.observable(false),
            onClickApply(): void {
                caller.loadDailyDownloadsReport();
            },
        };
    }

    public initializeDatePickers(): void {
        this.dateFilter.buildCalendarWhenReady();
    }

    public setRows(rows: any[]): void {
        this.getTemplateViewModel().rows(rows);
    }

    public getRequestPayload(): { startDate: string; endDate: string } {
        const df = this.dateFilter.getTemplateViewModel();
        return {
            startDate: df.startDate(),
            endDate: df.endDate(),
        };
    }

    public setDefaultDates(startYmd: string, endYmd: string): void {
        const start = new Date(startYmd + "T00:00:00");
        const end = new Date(endYmd + "T23:59:59");
        if (!isNaN(start.getTime()) && !isNaN(end.getTime())) {
            this.dateFilter.setDateRange(start, end);
        }
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/modReportsDailyDownloads_template.ts